// utils/getClientSource.js
export const getClientSource = () => {
  const isInstalledPwa =
    // Modern PWA detection
    window.matchMedia("(display-mode: standalone)").matches ||
    // Legacy iOS (<17)
    (typeof window.navigator.standalone !== "undefined" &&
      window.navigator.standalone === true);

  return isInstalledPwa ? "mobile.solidarity" : "online.solidarity";
};
